import { Notify } from 'utils';

export const errorHandler = (error: any) =>
  Notify.error(error.response?.data?.error || error.message);
